import React from 'react';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';
import { companyInfo } from '../mock';
import Reveal from './Reveal';

const ContactInfo = () => {
  return (
    <div className="mt-10 space-y-6">
      <Reveal delay={100}>
        <div className="flex items-start gap-4">
          <div className="w-11 h-11 rounded-full bg-white flex items-center justify-center text-[#7B1E24] border border-[#E5DED0]">
            <Phone size={16} />
          </div>
          <div>
            <div className="text-[11px] tracking-[0.24em] uppercase text-[#7a7268]">Call</div>
            <a
              href={`tel:${companyInfo.phone1.replace(/\s/g, '')}`}
              className="block text-[#1a1a1a] hover:text-[#7B1E24] transition-colors"
            >
              {companyInfo.phone1}
            </a>
            <a
              href={`tel:${companyInfo.phone2.replace(/\s/g, '')}`}
              className="block text-[#1a1a1a] hover:text-[#7B1E24] transition-colors"
            >
              {companyInfo.phone2}
            </a>
          </div>
        </div>
      </Reveal>

      <Reveal delay={160}>
        <div className="flex items-start gap-4">
          <div className="w-11 h-11 rounded-full bg-white flex items-center justify-center text-[#7B1E24] border border-[#E5DED0]">
            <MapPin size={16} />
          </div>
          <div>
            <div className="text-[11px] tracking-[0.24em] uppercase text-[#7a7268]">Showroom</div>
            <div className="text-[#1a1a1a]">{companyInfo.address}</div>
          </div>
        </div>
      </Reveal>

      <Reveal delay={220}>
        <a
          href={companyInfo.instagram}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-3 pt-2 group"
        >
          <span className="w-11 h-11 rounded-full bg-white border border-[#E5DED0] flex items-center justify-center text-[#1a1a1a] group-hover:bg-[#7B1E24] group-hover:text-white group-hover:border-[#7B1E24] transition-all">
            <Instagram size={16} />
          </span>
          <span className="text-[#1a1a1a] group-hover:text-[#7B1E24] transition-colors">
            @cherrystonesg
          </span>
        </a>
      </Reveal>
    </div>
  );
};

export default ContactInfo;
